import ExpoConstants from 'expo-constants';
import type { ImageLoadEventData, ImageSource, ImageContentFit } from 'expo-image';
import { Image } from 'expo-image';
import type { ImageStyle, StyleProp } from 'react-native';

interface Props {
	source: ImageSource | string | number | null;
	style?: StyleProp<ImageStyle>;
	onLoad?: (event: ImageLoadEventData) => void;
	contentFit?: ImageContentFit;
}

function ThermenImage({ source, style, onLoad, contentFit }: Props) {
	const appVersion = ExpoConstants?.expoConfig?.version ?? '';

	let imageSource: ImageSource | number | string = {};

	if (typeof source === 'string' || typeof source === 'number') {
		imageSource = source;
	} else if (source instanceof Object && 'uri' in source) {
		imageSource = { uri: source.uri, cacheKey: source.uri + appVersion };
	}

	return (
		<Image {...(contentFit ? { contentFit } : {})} {...(onLoad ? { onLoad } : {})} source={imageSource} style={style} />
	);
}

export default ThermenImage;
